// Docs: https://marmelab.com/react-admin/Authorization.html
// Docs: https://marmelab.com/react-admin/Authentication.html
import { AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT } from 'react-admin';

import { getToken, removeTokens, getRole } from './token';
import { Intercom } from './utils';

const login_uri = process.env.REACT_APP_API_LOGIN_CHECK_ENTRYPOINT;

export default (type, params) => {
  switch (type) {
    case AUTH_LOGIN:
      const {username, password} = params;
      const request = new Request(`${login_uri}`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({email: username, password}),
        headers: new Headers({'Content-Type': 'application/json'}),
      });
      return fetch(request)
        .then(response => {
          if (response.status < 200 || response.status >= 300) {
            return Promise.reject(response.message);
          }
          return Promise.resolve();
        })
        .then(() => {

          window.location.replace('/');
        });

    case AUTH_LOGOUT:
      removeTokens();
      Intercom.reset();
      return Promise.resolve();

    case AUTH_CHECK:
      return getToken() ? Promise.resolve() : Promise.reject();

    case AUTH_ERROR:
      const status = { params };
      if (status === 401 || status === 403) {
        removeTokens();
        Intercom.reset();
        return Promise.reject();
      }
      return Promise.resolve();

    case AUTH_GET_PERMISSIONS:
      const role = getRole();
      return role ? Promise.resolve(role) : Promise.reject();

    default:
      return Promise.resolve();
  }
};
